<div class="container">

  <ngb-alert
    *ngIf="optInAlert"
    class="sticky-top my-3"
    (closed)="closeOptInAlert()"
    style="top: 10px"
    [type]="optInAlert.type"
  >
    {{ optInAlert.message }}
  </ngb-alert>

  <div class="andoroid-app-banner-container">
    <android-app-banner></android-app-banner>
  </div>
  <app-register-stepper [progressData]="getProgressData()" [user]="user"></app-register-stepper>

  <div *ngIf="areTheInitialRegistrationStepsIncomplete()" class="row progress-buttons-wrapper">
    <div class="user-progress-detail-wrapper col-3">
      <div class="me-1">
        <div class="user-progress-detail-label mb-1">Keeper details</div>
        <button
          type="button"
          [disabled]="isFullNameRegistrationCompleted"
          class="btn btn-identialert-color w-100 user-progress-detail-button"
          [ngClass]="isFullNameRegistrationCompleted ? 'registration-step-completed' : ''"
          [routerLink]="['/account/owner-details']"
        >
          {{ isFullNameRegistrationCompleted ? 'Done' : 'Not complete' }}
        </button>
      </div>
    </div>
    <div *ngIf="isFullNameRegistrationCompleted" class="user-progress-detail-wrapper col-3">
      <div class="me-1">
        <div class="user-progress-detail-label mb-1">Pet's details</div>
        <button
          type="button"
          [disabled]="!isFullNameRegistrationCompleted || isPetChipNumberRegistrationCompleted"
          class="btn btn-identialert-color w-100 user-progress-detail-button"
          [ngClass]="isPetChipNumberRegistrationCompleted ? 'registration-step-completed' : ''"
          (click)="navigateToClaimPetOrEditPet()"
        >
          {{ isPetChipNumberRegistrationCompleted ? 'Done' : 'Not complete' }}
        </button>
      </div>
    </div>
    <div
      *ngIf="isFullNameRegistrationCompleted && isPetChipNumberRegistrationCompleted"
      class="user-progress-detail-wrapper col-3"
    >
      <div class="me-1">
        <div class="user-progress-detail-label mb-1">Membership selection</div>
        <button
          type="button"
          [disabled]="
            !isFullNameRegistrationCompleted ||
            !isPetChipNumberRegistrationCompleted ||
            isMembershipSelectionCompleted
          "
          class="btn btn-identialert-color w-100 user-progress-detail-button"
          [ngClass]="isMembershipSelectionCompleted ? 'registration-step-completed' : ''"
          [routerLink]="['/account/membership-options']"
        >
          {{ isMembershipSelectionCompleted ? 'Done' : 'Not complete' }}
        </button>
      </div>
    </div>
    <div
      *ngIf="
        isFullNameRegistrationCompleted &&
        isPetChipNumberRegistrationCompleted &&
        isMembershipSelectionCompleted
      "
      class="user-progress-detail-wrapper col-3"
    >
      <div class="me-1">
        <div class="user-progress-detail-label mb-1">Free Petplan Insurance</div>
        <button
          type="button"
          [disabled]="
            !isFullNameRegistrationCompleted ||
            !isPetChipNumberRegistrationCompleted ||
            !isMembershipSelectionCompleted ||
            isWelcomePackSelectCompleted
          "
          class="btn btn-identialert-color w-100 user-progress-detail-button"
          [ngClass]="isWelcomePackSelectCompleted ? 'registration-step-completed' : ''"
          [routerLink]="['/welcome-gift']"
        >
          {{ isWelcomePackSelectCompleted ? 'Done' : 'Not complete' }}
        </button>
      </div>
    </div>
  </div>

  <span [ngClass]="isMembershipSelectionCompleted ? '' : 'blur-content'">
    <div class="row pt-4">
      <div [ngClass]="isDeviceTypeMobile ? 'col-lg-10' : 'col-lg-8'" class="col-md-12 col-sm-12">
        <h1 class="d-flex flex-row justify-content-start flex-wrap align-items-center">
          <span class="fw-light">Hi {{ user.name.firstName }}!</span>
          <span class="ms-2 badges">
            <span
              *ngIf="user.originalProductType === productType.Premium"
              class="badge custom-badge"
            >
              <div *ngIf="user.ultimate; else identialert">
                <h5 class="fw-bold text-primary mb-0">
                  identi
                  <span class="text-success">find</span>
                </h5>
              </div>
              <ng-template #identialert>
                <h5 class="fw-bold text-primary mb-0">
                  identi
                  <span class="text-danger">alert</span>
                </h5>
              </ng-template>
            </span>
            <button
              *ngIf="userService.isUserBasic(user.originalProductType)"
              routerLink="/account/account-type"
              class="badge bg-primary btn btn-primary me-2"
              [disabled]="areTheInitialRegistrationStepsIncomplete()"
            >
              Basic
            </button>
            <button
              *ngIf="user.originalProductType === productType.BasicPlus"
              routerLink="/account/account-type"
              class="badge bg-secondary btn btn-secondary text-white me-2"
              [disabled]="areTheInitialRegistrationStepsIncomplete()"
            >
              identibase+
            </button>
            <button
              *ngIf="user.originalProductType === productType.LegacyPremium"
              class="badge bg-primary"
              [disabled]="areTheInitialRegistrationStepsIncomplete()"
            >
              Premium
            </button>
            <button
              *ngIf="user.originalProductType === productType.LegacyPlus"
              routerLink="/account/account-type"
              class="badge bg-primary btn btn-primary me-2"
              [disabled]="areTheInitialRegistrationStepsIncomplete()"
            >
              Plus
            </button>
            <button
              [routerLink]="['/my-pets']"
              class="badge bg-primary btn btn-primary me-2"
              trackClickEvent
              [eventNumber]="ClickEventNumbersEnum.PetDetails"
              [disabled]="areTheInitialRegistrationStepsIncomplete()"
            >
              My pets
            </button>
            <button
              class="badge bg-primary btn btn-primary me-2"
              [disabled]="areTheInitialRegistrationStepsIncomplete()"
              (click)="scrollToOffers()"
            >
              See your offers and perks
            </button>
          </span>
          <mat-chip-set aria-label="Dog selection" *ngIf="alivePets.length > 0">
            <mat-chip *ngFor="let pet of alivePets" [routerLink]="navigateToPetDetailPage(pet.id)">
              <div *ngIf="pet.isTokPaymentRequired" class="mat-chip-avatar-orange" matChipAvatar></div>
              <div *ngIf="pet.isTokPaymentRequired" class="mat-chip-avatar-icon" matChipAvatar>❕</div>
              <img matChipAvatar [src]="getPetImageUrl(pet.imageId)" alt="Photo of the pet" />
              {{ pet.name }}
            </mat-chip>
          </mat-chip-set>
        </h1>

        <h3>
          {{ welcomeMessage }}
        </h3>
      </div>
      <div *ngIf="!isDeviceTypeMobile" class="dashboard-QR-container px-0">
        <img class="dashboard-QR" [src]="qrcode" alt="dashboard-QR" />
      </div>
    </div>

    <div class="container">
      <div class="row mb-3 mt-2">
        <div class="col-12">
          <app-pricing-table
            [hidePrices]="false"
            [showInfoLine]="true"
            [disabled]="loading || areTheInitialRegistrationStepsIncomplete()"
            [pricingPlans]="pricingPlans"
            [user]="user"
            [buttonLabel]="'Buy now'"
            (onSelect)="select($event)"
            (onNavigateToProductPage)="navigateToProductPage($event)"
          ></app-pricing-table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <ngb-alert
          *ngIf="alert"
          class="sticky-top my-3"
          (closed)="closeAlert()"
          style="top: 10px"
          [type]="alert.type"
        >
          {{ alert.message }}
        </ngb-alert>

        <ngb-alert
          *ngIf="incompletePetRegistations.length"
          class="my-3"
          [dismissible]="false"
          [type]="'warning'"
        >
          <div class="row">
            <div class="col-12 col-md-8">
              <p class="mb-2 mb-md-0">
                <strong>Complete your registration</strong>
                <br />
                You haven't finished registering your
                {{ incompletePetRegistations.length > 1 ? 'pets' : 'pet' }}
                yet!
                <br />
              </p>
            </div>
            <div
              class="col-12 col-md-4 text-center text-md-end d-flex flex-row justify-content-center justify-content-md-end align-items-center"
            >
              <button
                class="btn btn-secondary text-white mt-1"
                [disabled]="areTheInitialRegistrationStepsIncomplete()"
                [routerLink]="
                  incompletePetRegistations.length > 1
                    ? '/my-pets'
                    : ['/my-pet', incompletePetRegistations[0].id, 'confirm']
                "
              >
                <p class="mb-0">
                  <strong>Complete</strong>
                </p>
              </button>
            </div>
          </div>
        </ngb-alert>

        <ngb-alert
          *ngFor="let pet of missingPetsWithNoReport"
          [dismissible]="false"
          [type]="'info'"
          class="my-3"
        >
          <h4 class="alert-heading">
            {{ pet.name }} is
            {{ pet.residence === petResidenceStatus.Lost ? 'missing' : 'stolen' }}.
          </h4>
          <div class="row">
            <div class="col-12">
              <p>
                Someone has reported your pet as missing. Please
                <a class="alert-link" [routerLink]="['/my-pet', pet.id, 'report-missing']">
                  create your missing pet report here
                </a>
                so we can help find {{ pet.name }}.
              </p>
            </div>
          </div>
        </ngb-alert>

        <!-- <ngb-alert
          *ngIf="user.productType !== productType.Premium"
          class="my-3"
          [dismissible]="false"
          [type]="'success'">
          <div class="row">
            <div class="col-12 col-md-8">
              <p class="mb-2 mb-md-0">
                <strong>Upgrade to Premium</strong><br/>
                [copy here about why you should upgrade to Premium]
              </p>
            </div>
            <div class="col-12 col-md-4 text-start text-md-end d-flex flex-row justify-content-end align-items-center">
              <div
                class="btn btn-success text-white mt-1"
                [routerLink]="['/account/account-type']">
                <p class="mb-0">
                  <strong>Upgrade</strong>
                </p>
              </div>
            </div>
          </div>
        </ngb-alert> -->
      </div>
    </div>
  </span>
</div>

<div class="container">
  <div class="row ms-2">
    <h3 class="mb-1 mt-1 px-0">Don't miss your pet perks!</h3>
    <p class="mb-0 px-0">
      From food, pet care and insurance to training, treats and toys, we've got big savings for our
      identibase pet parents.
    </p>
  </div>
</div>

<div id="offerListHeader" class="pt-5 pb-3 bg-light partner-offers">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div *ngIf="perks.length" class="row d-flex justify-content-between align-items-stretch">
          <div class="col-12 mb-3 perk-wrapper" [ngClass]="{ 'perk-preview': previewPremium }">
            <div class="row">
              <div
                *ngFor="let perk of perks; let perkIndex = index"
                class="col-12 d-inline-flex"
                [ngClass]="{
                  'large-col': perk.widget.widgetSize == WidgetSize.Large,
                  'mid-col':
                    perk.widget.widgetSize !== WidgetSize.Large &&
                    perk.widget.widgetSize !== WidgetSize.Small,
                  'small-col': perk.widget.widgetSize == WidgetSize.Small
                }"
              >
                <app-perk-widget
                  class="mb-4"
                  [enabled]="
                    (!perk.disabled && !areTheInitialRegistrationStepsIncomplete()) ||
                    perk.widget.redirectUri === 'welcome-gift'
                  "
                  [disabledText]="'Complete the registration flow to access the offer'"
                  [widgetSize]="perk.widget.widgetSize"
                  [perk]="perk"
                  [totalNumberOfPerks]="perks.length"
                  [currentPerkNumber]="perkIndex + 1"
                  [preview]="previewPremium"
                  (lastPerkRendered)="onLastPerkRendered()"
                ></app-perk-widget>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
